import {getElement} from "./utils/getElement";

const initTableOfContent = () => {
    const tocSide = getElement('.js-toc')
    const tocMain = getElement('.js-toc-main')
    const headings = [];

    const tocToggle = getElement('.js-toc-toggle')

    if (tocSide) {
        const tocMainHeadings = tocMain.querySelectorAll('h2, h3'); // Filtering only h2 and h3 headings

        tocMainHeadings.forEach((heading, index) => {
            const id = heading.textContent.toLowerCase().replace(/ /g, '-') + "-" + index.toString();
            heading.setAttribute('id', id);
            headings.push({ title: heading.textContent, id: id });
        });

        headings.forEach((heading, index) => {
            // Check if the current item is the first in the array
            const className = index === 0 ? 'is-active' : ''; // Add class if it's the first item
            const linkTag = `<div><a href="#${heading.id}" class="${className}">${heading.title}</a></div>`;
            tocSide.insertAdjacentHTML('beforeend', linkTag);
        });


        if (tocToggle) {
            tocToggle.addEventListener('click', function () {
                if (window.matchMedia("(max-width: 768px)").matches) {
                    this.classList.toggle('is-open');
                    const tocWrap = document.querySelector('.js-toc-wrap');
                    if (tocWrap.style.display === 'none' || tocWrap.style.display === '') {
                        tocWrap.style.display = 'block';
                    } else {
                        tocWrap.style.display = 'none';
                    }
                }
            });
        }
    }

    function getHeadingsPos() {
        const tocMainHeadings = tocMain.querySelectorAll('h2, h3');
        const headingsWithPos = [];

        tocMainHeadings.forEach(heading => {
            const pos = heading.getBoundingClientRect().top + window.pageYOffset;
            headingsWithPos.push({ 'id': heading.getAttribute('id'), 'pos': Math.floor(pos) });
        });

        return headingsWithPos;
    }

    if (window.matchMedia("(min-width: 992px)").matches && tocSide) {
        const pageHeadings = getHeadingsPos().reverse();

        window.addEventListener('scroll', () => {
            const topPos = window.scrollY;

            for (const heading of pageHeadings) {
                if (heading.pos - 200 < topPos) {
                    document.querySelectorAll('.js-toc a').forEach(a => a.classList.remove('is-active'));
                    const activeLink = document.querySelector(`a[href="#${heading.id}"]`);
                    if (activeLink) {
                        activeLink.classList.add('is-active');
                    }
                    break;
                }
            }
        });
    }
}

export {initTableOfContent}
